export default __webpack_public_path__ + "static/s02-961b35af12b703db984aebecbf408e55.png";